import { Typography } from '@mui/material'
import React from 'react'

export default function SectionTitle({ title }) {
    return (
        <Typography variant='p' className='section_title heading_five'>
            {title}
        </Typography>
    )
}
